/** Canonical body region options — single source of truth for display labels. */
export const BODY_REGIONS: { value: string; label: string; short: string }[] = [
  { value: 'head_neck', label: 'Head / Neck', short: 'Head' },
  { value: 'left_shoulder', label: 'Left Shoulder', short: 'L.Shldr' },
  { value: 'right_shoulder', label: 'Right Shoulder', short: 'R.Shldr' },
  { value: 'upper_back', label: 'Upper Back', short: 'U.Back' },
  { value: 'lower_back', label: 'Lower Back', short: 'L.Back' },
  { value: 'left_hip', label: 'Left Hip', short: 'L.Hip' },
  { value: 'right_hip', label: 'Right Hip', short: 'R.Hip' },
  { value: 'left_quad', label: 'Left Quad', short: 'L.Quad' },
  { value: 'right_quad', label: 'Right Quad', short: 'R.Quad' },
  { value: 'left_hamstring', label: 'Left Hamstring', short: 'L.Ham' },
  { value: 'right_hamstring', label: 'Right Hamstring', short: 'R.Ham' },
  { value: 'left_knee', label: 'Left Knee', short: 'L.Knee' },
  { value: 'right_knee', label: 'Right Knee', short: 'R.Knee' },
  { value: 'left_ankle', label: 'Left Ankle', short: 'L.Ankle' },
  { value: 'right_ankle', label: 'Right Ankle', short: 'R.Ankle' },
  { value: 'left_calf', label: 'Left Calf', short: 'L.Calf' },
  { value: 'right_calf', label: 'Right Calf', short: 'R.Calf' },
  { value: 'left_bicep', label: 'Left Bicep', short: 'L.Bicep' },
  { value: 'right_bicep', label: 'Right Bicep', short: 'R.Bicep' },
  { value: 'left_tricep', label: 'Left Tricep', short: 'L.Tri' },
  { value: 'right_tricep', label: 'Right Tricep', short: 'R.Tri' },
  { value: 'left_forearm', label: 'Left Forearm', short: 'L.Forearm' },
  { value: 'right_forearm', label: 'Right Forearm', short: 'R.Forearm' },
  { value: 'left_wrist', label: 'Left Wrist', short: 'L.Wrist' },
  { value: 'right_wrist', label: 'Right Wrist', short: 'R.Wrist' },
  { value: 'left_shin', label: 'Left Shin', short: 'L.Shin' },
  { value: 'right_shin', label: 'Right Shin', short: 'R.Shin' },
  { value: 'left_groin', label: 'Left Groin', short: 'L.Groin' },
  { value: 'right_groin', label: 'Right Groin', short: 'R.Groin' },
  { value: 'left_foot', label: 'Left Foot', short: 'L.Foot' },
  { value: 'right_foot', label: 'Right Foot', short: 'R.Foot' },
  { value: 'other', label: 'Other', short: 'Other' },
];

/** Abbreviated region names for compact display (table rows). */
export const REGION_SHORT: Record<string, string> = Object.fromEntries(
  BODY_REGIONS.map(r => [r.value, r.short])
);

/** Full region names for expanded views and forms. */
export const REGION_FULL: Record<string, string> = Object.fromEntries(
  BODY_REGIONS.map(r => [r.value, r.label])
);
